import { t } from 'i18next';
import { PlusCircleFill, StarShape } from '@peacecover/icon';
import { useGetMembersWithLeastPhotoCards } from '@pocapan/shared/domains/members/ui/hooks/useGetMembersWithLeastPhotoCards';
import { useGetLatestPhotoCards } from '@pocapan/shared/domains/photoCards/ui/hooks/useGetLatestPhotoCards';
import HorizontalScroll from '../../my-page/components/HorizontalScroll';
import LatestPhotoCardItem from './LatestPhotoCardItem';
import MemberWithLeastPhotoCardsItem from './MemberWithLeastPhotoCardsItem';

const HomeView = () => {
  const { data: members } = useGetMembersWithLeastPhotoCards();
  const { data: latestPhotoCardsData } = useGetLatestPhotoCards();
  const latestPhotoCards = latestPhotoCardsData?.pages.flatMap((page) => page.photoCards) ?? [];

  return (
    <div className="flex flex-col px-[24px] gap-[20px] mt-[24px] pb-[150px]">
      <HorizontalScroll className="mx-[-24px] px-[24px]">
        <div className="flex items-center gap-[10px]">
          <GuideBannerCard
            className="bg-[linear-gradient(180deg,#DF93FF_0%,#9D76FF_100%)]"
            label={t('HomeView.guideBannerNewbieLabel')}
            title={t('HomeView.guideBannerNewbieTitle')}
            rightElement={
              <div className="absolute top-[13px] right-[14px]">
                <img
                  src="/assets/collections/pocapan_guide_icon.png"
                  alt="pocapan guide icon"
                  className="text-[#CD8BFF] mix-blend-overlay h-[25px]"
                />
              </div>
            }
          />
          <GuideBannerCard
            className="bg-[linear-gradient(180deg,#93A8FF_0%,#5777FF_100%)]"
            label={t('HomeView.guideBannerEtiquetteLabel')}
            title={t('HomeView.guideBannerEtiquetteTitle')}
            rightElement={
              <div className="absolute top-[11px] right-[9.5px]">
                <img
                  src="/assets/collections/seller_guide_icon.png"
                  alt="seller guide icon"
                  className="text-[#7F98FF] mix-blend-overlay w-[36.5px]"
                />
              </div>
            }
          />
        </div>
      </HorizontalScroll>
      <div>
        <div className="flex items-center justify-between py-[4px]">
          <div className="flex items-center gap-[4px]">
            <StarShape size={18} className="text-text-main-lv2" />
            <p className="text-[15px] font-bold leading-[18px] text-text-main-lv2">
              {t('HomeView.latestUpdatesTitle')}
            </p>
          </div>
        </div>
        <div className="mt-[16px] grid grid-cols-5 gap-x-[7px] gap-y-[10px]">
          {latestPhotoCards.map((photoCard) => (
            <LatestPhotoCardItem key={photoCard.photoCardId} photoCard={photoCard} />
          ))}
        </div>
      </div>
      <div className="mt-[4px]">
        <div className="flex items-center justify-between py-[4px]">
          <div className="flex items-center gap-[4px]">
            <PlusCircleFill size={18} className="text-text-main-lv2" />
            <p className="text-[15px] font-bold leading-[18px] text-text-main-lv2">
              {t('HomeView.waitingForReportsTitle')}
            </p>
          </div>
          <p className="text-[11px] leading-[13px] text-text-main-lv2">
            {t('HomeView.firstCaptorDescription')}
          </p>
        </div>
        <HorizontalScroll className="mt-[8px] py-[8px]">
          <div className="flex items-center gap-[10px]">
            {members?.map((member) => (
              <MemberWithLeastPhotoCardsItem key={member.memberId} member={member} />
            ))}
          </div>
        </HorizontalScroll>
      </div>
    </div>
  );
};

interface GuideBannerCardProps {
  className: string;
  label: string;
  title: string;
  rightElement?: React.ReactNode;
}

const GuideBannerCard = ({
  className,
  label,
  title,
  rightElement = null
}: GuideBannerCardProps) => (
  <div
    className={`${className} relative pl-[15px] pb-[15px] pt-[41px] flex flex-col items-start gap-[4px] w-[169px] rounded-[18px]`}
  >
    <p className="text-[12px] font-medium leading-[14px] text-white">{label}</p>
    <p className="text-[15px] font-semibold leading-[18px] text-white">{title}</p>
    {rightElement}
  </div>
);

export default HomeView;
